import {
  pricingPlansBundle,
  pricingPlansCall,
  pricingPlansChat,
} from '../config/billingPlansConfig';
import type { Price } from '../interfaces/Price';

type UsageLimits = {
  minutesLimit: number | null;
  messagesLimit: number | null;
};

const PLAN_LIMITS_BY_ID = new Map(
  (
    [...pricingPlansCall, ...pricingPlansChat, ...pricingPlansBundle] as Price[]
  ).map(p => [
    p.id,
    {
      minutesLimit:
        typeof p.minutes === 'number' && p.minutes > 0 ? p.minutes : null,
      messagesLimit:
        typeof p.messages === 'number' && p.messages > 0 ? p.messages : null,
      isEnterprise: p.tier === 'enterprise',
    },
  ])
);

function positiveLimit(value: number | null | undefined): number | null {
  if (value == null || value <= 0) return null;
  return value;
}

/**
 * Resolve displayable limits using usage API values first, then plan-id fallback.
 * Returns `null` only when the limit is truly unknown.
 */
export function resolveUsageLimitsFromPlan(
  planId: string | undefined,
  minutesLimitFromUsage: number | null | undefined,
  messagesLimitFromUsage: number | null | undefined
): UsageLimits {
  const plan = planId ? PLAN_LIMITS_BY_ID.get(planId) : undefined;

  let minutesLimit = positiveLimit(minutesLimitFromUsage);
  let messagesLimit = positiveLimit(messagesLimitFromUsage);

  if (minutesLimit == null && plan && !plan.isEnterprise) {
    minutesLimit = plan.minutesLimit;
  }
  if (messagesLimit == null && plan && !plan.isEnterprise) {
    messagesLimit = plan.messagesLimit;
  }

  return { minutesLimit, messagesLimit };
}
